'use client';

import type { ComponentProps } from 'react';
import { Tooltip } from '~/components/primitives';
import { useIsDesktop } from '~/components/primitives/hooks/useIsDesktop';

/**
 * A tooltip that only exists where hovering does.
 *
 * On touch there is no hover, so these opened on tap — swallowing the tap, covering the thing
 * the user was reaching for, and needing a second tap elsewhere to dismiss. Anything the
 * tooltip says must therefore also be readable without it; this only removes a control that
 * cannot work, it does not hide information.
 */
export const HoverTooltip: React.FC<ComponentProps<typeof Tooltip>> = props => (
    <Tooltip {...props} enabled={useIsDesktop() && props.enabled !== false} />
);
